export const bidType = {
  BI: 'Bid without Exception',
  BW: 'Bid With Exception',
  AB: 'Alternate Bid',
  DQ: 'No Bid',
};

export const discountCodes = {
  '0': 'No Discount',
  '1': 'Net 30',
  '10': '2% 10 Days',
  '3': '1/2% 20 Days',
  '6': '1/2% 10 Days',
  '8': '1/4% 20 Days',
};

export const boaFssBpa = {
  NAP: 'N/A',
  FSS: 'FSS',
  BOA: 'BOA',
  BPA: 'BPA',
};

export const destOrigin = {
  D: 'Destination',
  O: 'Origin',
};

export const countries = {
  US: 'United States of America',
  CA: 'Canada',
};

export const yesOrNo = {
  Y: 'Yes',
  N: 'No',
};

export const childCode = {
  N: 'No',
  U:
    'May Supply, but not aware of any such use of child labor based on good faith effort.',
  Y: 'Yes',
};



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/optionsJson/contract.js